import { useState, useEffect } from 'react';
import { PackageService } from '../services/packageService';
import { Destination } from '../config/api';

export const useDestinations = () => {
  const [destinations, setDestinations] = useState<Destination[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDestinations = async () => {
      try {
        setLoading(true);
        const service = PackageService.getInstance();
        const data = await service.getDestinations();
        setDestinations(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch destinations');
      } finally {
        setLoading(false);
      }
    };

    fetchDestinations();
  }, []);

  return { destinations, loading, error };
}; 